var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _vm.assigned &&
      !_vm.paused &&
      !_vm.rejected &&
      ["1", "2", "3", "5"].includes(_vm.status) &&
      (_vm.isDispatcher || (_vm.isPEM && _vm.TPEM))
        ? _c("self-unassign", {
            staticClass: "mx-2",
            attrs: { requestId: _vm.requestId, groupId: _vm.groupId },
            on: { success: _vm.onUnassign }
          })
        : !_vm.assigned &&
          !_vm.rejected &&
          ["1", "2", "3", "5"].includes(_vm.status) &&
          (_vm.isDispatcher || (_vm.isPEM && _vm.TPEM))
        ? _c("self-assign", {
            staticClass: "mx-2",
            attrs: { requestId: _vm.requestId }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.paused && !_vm.rejected && _vm.status === "1" && _vm.isDispatcher
        ? _c("self-assign", {
            staticClass: "mx-2",
            attrs: {
              groupId: _vm.groupId,
              paused: "",
              requestId: _vm.requestId
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.rejected && ["1", "2", "3"].includes(_vm.status) && _vm.isDispatcher
        ? _c("request-affectation-btn-dialog", {
            staticClass: "mx-2",
            attrs: {
              entity_nav_full_id: _vm.entity_nav_full_id,
              "is-assigned": _vm.assigned,
              "is-paused": _vm.paused,
              item: _vm.item,
              "property-id": _vm.propertyId,
              requestId: _vm.requestId,
              "request-ordo": _vm.requestOrdo,
              technician_internal_id: _vm.technician_internal_id
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.rejected &&
      ["1", "2", "3"].includes(_vm.status) &&
      (_vm.isDispatcher || (_vm.isPEM && _vm.TPEM))
        ? _c("workorder-report-btn-dialog", {
            staticClass: "mx-2",
            attrs: {
              entity_nav_full_id: _vm.entity_nav_full_id,
              "is-assigned": _vm.assigned,
              "is-paused": _vm.paused,
              "is-pem-his": _vm.isPEM && _vm.TPEM,
              "property-id": _vm.propertyId,
              qualification: _vm.qualification,
              requestId: _vm.requestId,
              request: _vm.item,
              status: _vm.status,
              symptom: _vm.symptom,
              technician_internal_id: _vm.technician_internal_id
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.rejected &&
      ["1", "2", "3", "5"].includes(_vm.status) &&
      (_vm.isDispatcher || (_vm.isPEM && _vm.TPEM))
        ? _c("rejection-btn-dialog", {
            staticClass: "mx-2",
            attrs: {
              requestId: _vm.requestId,
              "is-paused": _vm.paused,
              "is-assigned": _vm.assigned
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.rejected && !_vm.paused && _vm.status === "1" && _vm.isDispatcher
        ? _c("pause-btn-dialog", {
            staticClass: "mx-2",
            attrs: { requestId: _vm.requestId }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.requestOrdo &&
      _vm.entityOrdo &&
      !_vm.rejected &&
      ["1", "2"].includes(_vm.status) &&
      _vm.isDispatcher
        ? _c("LinkToP2O", {
            staticClass: "mx-2",
            attrs: {
              "request-id": _vm.requestId,
              "is-paused": _vm.paused,
              "is-assigned": _vm.assigned
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }